export default __webpack_public_path__ + "static/media/pwa3.6542a5ca.jpg";